import { INatureAffairePieceJointe } from '@core-lib/models';
import { DocumentMetadata } from '@core-lib/modules/document-ged/models/alfresco.model';
import { createEntityActions, createTypedAction } from '@core-lib/store';
import { createAction } from '@ngrx/store';
import { EntityActionType } from '../entity-slice.function';

const ActionPrefix = 'Alfresco-documents';

export const CoordonneesBancairesDocsActions = {
	...createEntityActions<DocumentMetadata[]>(ActionPrefix, 'Get files'),
	LoadEntityRequest: createTypedAction(
		EntityActionType.LoadEntityRequest,
		`[${ActionPrefix}] Get CB files`,
		(operationId: string, coordonneesBancaireId: string, compteId?: string) => ({
			operationId,
			coordonneesBancaireId,
			compteId
		})
	)
};

export const {
	LoadEntityRequest: LoadCoordonneesBancairesDocsRequest,
	LoadEntitySuccess: LoadCoordonneesBancairesDocsSuccess,
	LoadEntityFailure: LoadCoordonneesBancairesDocsFailure
} = CoordonneesBancairesDocsActions;

export const OperationDocsActions = {
	...createEntityActions<DocumentMetadata[]>(ActionPrefix, 'Get files')
};

export const Reset = '[${ActionPrefix] Reset';
export const resetAction = createAction('[App] Reset');
